import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFieldArray } from 'react-hook-form';
import { ReactComponent as InfoIcon } from 'applicaiton/assets/info.svg';
import { ContactsType } from 'common/types/clinics';
import { ContactsChildProps, ContactsFormValues } from '../models';

import AddAnother from '../AddAnother';
import { InputPhone } from 'common/components';

import {
  Close,
  FlexContainer,
  InputContainer,
  LabelWrapper,
  WrapperContact,
} from '../styles';

const Phones = ({
  errors,
  control,
  register,
  getValues,
  handleRemoveContact,
}: ContactsChildProps) => {
  const { t } = useTranslation();

  const prependKey = 'phones';
  const { fields, append, remove } = useFieldArray<ContactsFormValues>({
    control,
    name: prependKey,
  });

  const handleAddAnother = () => {
    append({
      type: 'Phone' as ContactsType,
      contactDetail: '',
    });
  };

  const removeContact = (index: number) => {
    const contacts = getValues(prependKey);
    if (contacts.length) {
      const contactWithId = contacts.find(
        (item, idx) => !!item.id && idx === index,
      );
      if (contactWithId) {
        handleRemoveContact(contactWithId.id);
      }
    }
    remove(index);
  };

  const showRequiredIcon =
    getValues('phones')?.filter((item) => item.contactDetail).length === 0 ||
    errors?.phones?.length;

  return (
    <WrapperContact>
      <LabelWrapper>
        <label>{t('phone')}</label>
        {showRequiredIcon && <InfoIcon />}
      </LabelWrapper>
      {fields.map((field, index) => {
        const id = `${prependKey}.${index}.contactDetail`;
        const value = getValues(`${prependKey}.${index}.contactDetail`);
        const error = errors?.[prependKey]?.[index]?.contactDetail?.message;
        return (
          <FlexContainer key={field.id}>
            <InputContainer>
              <InputPhone
                id={id}
                value={value}
                isValid={!error}
                register={register}
                errorMessage={error}
                allowChangeDialCode={true}
              />
            </InputContainer>
            {index !== 0 && <Close onClick={() => removeContact(index)} />}
          </FlexContainer>
        );
      })}

      <AddAnother title={t('add_another')} onClick={handleAddAnother} />
    </WrapperContact>
  );
};

export default Phones;
